import { TmHttpClient } from '@treasury/core/http';

export async function getLoanPaymentDetails(id: string) {
    return (await TmHttpClient.getInstance()).request(`loans/${id}`, {
        method: 'GET',
    });
}
